export default __webpack_public_path__ + "media/color/grt-5198e609.svg";